import { DeviceRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * deviceOnUpdateData - Function that updates on database an existing device by id   
 * /devices/{id}  
 * method PUT 
 * @async-function
 */
const deviceOnUpdateData = async (token: string, model: DeviceRequestType, id: number) => {
    const response = await api.put(
        `/devices/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default deviceOnUpdateData;